import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerson = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 19,
	viewBox: "0 0 20 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#667085",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Person" }), /* @__PURE__ */ _jsx("path", {
		d: "M1 18C3.33579 15.5226 6.50702 14 10 14C13.493 14 16.6642 15.5226 19 18M14.5 5.5C14.5 7.98528 12.4853 10 10 10C7.51472 10 5.5 7.98528 5.5 5.5C5.5 3.01472 7.51472 1 10 1C12.4853 1 14.5 3.01472 14.5 5.5Z",
		stroke: "current",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgPerson;
